"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M8.16 11c-1.43.07-3.52.57-4.54 2h6.55z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M1 21h15.01v.98c0 .56-.45 1.01-1.01 1.01H2.01c-.56 0-1.01-.45-1.01-1.01zm19.49 2.31L16 18.83V19H1v-2h13.17l-2-2H1c0-3.24 2.46-5.17 5.38-5.79l-5.7-5.7L2.1 2.1 13 13l2 2 6.9 6.9zM10.17 13l-2-2c-1.42.06-3.52.56-4.55 2zM23 5h-5V1h-2v4h-5l.23 2h9.56l-1 9.97 1.83 1.83z"
}, "1")], 'NoFoodTwoTone');